<template>
  <v-list dense nav class="b-menu-folder-list">
    <!--  -->

    <template v-for="item in menuList">
      <v-list-item
        :key="item.title"
        :to="item.disabled ? null : item.route"
        :href="item.href"
        :target="item.target"
        :disabled="item.disabled"
        :class="{ 'px-0': mini, 'v-list-item--active is-active': selected.name === item.name }"
        @click="$emit('select', item)"
      >
        <v-list-item-avatar class="my-0">
          <v-icon
            :class="[item.iconClass]"
            v-text="item.icon"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="item.title" />
        </v-list-item-content>
      </v-list-item>
    </template>

    <!--  -->
  </v-list>
</template>

<script>


export default {
  name: 'BMenuFolderList',
  props: {
    mini: Boolean,
    selected: {
      type: Object,
      required: true,
    },
    menuList: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.b-menu-folder-list {
  .v-list-item--active:not(.is-active) {
    &:hover::before {
      opacity: 0.04;
    }

    &:not(:hover) {
      // pointer-events: none;
      cursor: default;

      &::before {
        content: none;
      }
    }
  }
}
</style>
